import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {fetchUsersAction} from '../actions/';
import UsersPage from '../components/Users/UsersPage';

class UsersContainer extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchUsersAction());
  }

  render() {
    const { actions } = this.props;
    const { userPage } = this.props;
    const { authInfo } = this.props;
    const { IsAdmin } = authInfo;

    return <UsersPage IsAdmin={IsAdmin} actions={actions} userPage={this.props.userPage} authInfo={authInfo}/>;
  }
}

UsersContainer.propTypes = {
  actions: PropTypes.shape({})
};
UsersContainer.defaultProps = {
  userPage : {
    Data : [],
    TotalPageCount : 0,
    PageIndex : 0
  }
};

function mapStateToProps(state) {
  const props = {userPage : state.currentUserPage, authInfo : state.authInfo};
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {fetchUsersAction};
  const actionMap = { actions : bindActionCreators(actions, dispatch) , dispatch};
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersContainer);



// WEBPACK FOOTER //
// ./containers/UsersContainer.js